import { useState } from "react";
import { LoadingSpinner } from "../LoadingSpinner"
import { pageRoutes, URL, separatorReturn } from "../dictionary"
import { useNavigate } from "react-router-dom";
import Select from 'react-select'
import axios from "axios";
import { collegeMap } from "../collegeMap";

const returnColor = (value) => {

  switch (value) {
    // Unknown
    case 1:
      return '#8B8589'
    // Reach
    case 2:
      return '#8D1516'
    // Target
    case 3:
      return '#002147'
    // Safety
    case 4:
      return '#00C16F'
    default:
      return '#8B8589'
  }
}

const selectStyles = (fitVal) => {
  return {
    control: (provided, state) => ({
      ...provided,
      border: 'transparent',
      borderRadius: '10px',
      background: returnColor(fitVal)
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display: 'none'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: 'white'
    }),
  }
}

const CollegesOfInterest = ({ user, setUser, userCollegeInterest, setUserCollegeInterest, userData, mobile = false }) => {

  let navigate = useNavigate();

  const [saveError, setSaveError] = useState('')

  const options = [
    { value: 1, label: mobile ? 'Select' : 'Unknown', icon: <i className="bi bi-chevron-compact-down"></i> },
    { value: 2, label: 'Reach', icon: <i className="bi bi-chevron-compact-down"></i> },
    { value: 3, label: 'Target', icon: <i className="bi bi-chevron-compact-down"></i> },
    { value: 4, label: 'Safety', icon: <i className="bi bi-chevron-compact-down"></i> }
  ]

  const returnLabel = (fitVal) => {
    switch (fitVal) {
      case 1:
        return mobile ? 'Select' : 'Unknown'
      case 2:
        return 'Reach'
      case 3:
        return 'Target'
      case 4:
        return 'Safety'
      default:
        return 'Unknown'
    }
  }

  const returnCollegeName = (collegeId: string) => {
    const college = collegeMap?.find((item) => item.id == collegeId);
    return college ? college.name : '-';
  };

  const handleRemoveCollege = async (userId, collegeId) => {
    try {
      const collegeObjectToRemove = userCollegeInterest.find((item) => item.college_id == collegeId && item.user_profile_id == userId)

      const pk = collegeObjectToRemove.id

      const del = await axios.delete(`${URL}/user_college_interest/delete/${pk}`)

      console.log('College removed from list,', del.data)

      const res = await axios.get(`${URL}/user_college_interest`)

      res.data.filter((item) => item.user_profile_id === userData.user_id)

      setUserCollegeInterest(res.data.filter((item) => item.user_profile_id === userData.user_id))

      console.log('User college list retrieved,', res.data)
    } catch (error) {
      console.log(error)
      setSaveError(`Cannot remove ${returnCollegeName(collegeId)} at this time. Try again later.`)

      throw (error)
    }
  }

  const handleUserSelectedFitSelect = async (selectedOption, pk) => {

    try {
      // #1457
      // Adds userSelected field, set to true when selected fit is not Unknown. When selecting Unknown, resets userSelected to false to allow system to choose once again re:

      // on your second point, i don’t think it is necessary to prevent changes to saved colleges with fit value in the “indicate fit” position. if that gets updated automatically user would still theoretically be able to change back to unknown and I think that’s sufficient.
      // Ok just to confirm then, since the latest update was made to assign fit values when possible following the user making changes to their user data & when saving additional colleges.. this means that--
      // User wants to reset their fit for a college to ‘Unknown’ for whatever reason. Does so in the user profile page Colleges of Interest tab
      // Then goes to update their user data (and gpa, class rank/tier is non-null).. or saves additional colleges
      // If there is sufficient user data, the ‘Unknown’ they just toggled would be set to a system computed fit since no user selected was specifically tracked.
      // User then needs to select ‘Unknown’ again if they want to set the college to this value. Will continue to do so following any other user changes while gpa/class rank/tier is non-null

      const patch = await axios.patch(`${URL}/user_college_interest/${pk}`, { fit: selectedOption.value, userSelected: selectedOption.value === 1 ? false : true })

      console.log('Patch successful:', patch.data)

      const res = await axios.get(`${URL}/user_college_interest`)

      res.data.filter((item) => item.user_profile_id === userData.user_id)

      setUserCollegeInterest(res.data.filter((item) => item.user_profile_id === userData.user_id))

      // console.log('User college list retrieved,', res.data)

    } catch (error) {
      console.log(error)
      alert(`Encountered an error updating the college fit value. Please try again later.`)
      throw (error)
    }

  }

  const addCollegesButton = mobile ? (
    <div
      className='dca-college-search-resources-links'
      style={{ paddingLeft: '35px', paddingBottom: '10px' }}
      onClick={() => navigate(pageRoutes.collegeSearch)}
    >Add Colleges</div>) : <button
      type="button"
      style={{ marginRight: '25px' }}
      className='dca-userProfile-save-changes-button'
      onClick={() => navigate(pageRoutes.collegeSearch)}
    >
    Add Colleges
  </button>

  const separatorElement = (index) => mobile ? index != userCollegeInterest.length && <div className="separator" style={{ width: '100%' }}></div> : <div className={separatorReturn(index, userCollegeInterest)} style={{ width: '95%' }}></div>

  return userData && userCollegeInterest ? (
    <div className="dca-userProfile-form-card" style={{ width: '100%' }}>
      <div className={`dca-userProfile-collegeInterest`}>
        <div className="dca-userProfile-form-title">Colleges of Interest</div>
        {addCollegesButton}
      </div>
      <div className="separator"></div>

      <div className="d-flex justify-content-center">
        {saveError != '' && <span style={{ margin: '15px 15px', color: 'red' }}>{saveError}</span>}
      </div>

      <div
        className="d-flex flex-wrap">
        {userCollegeInterest.map((res, index) =>
          <div
            key={index}
            style={{ width: mobile ? '100%' : '50%' }}>
            <div className="dca-userProfile-interest-field">
              <div style={{ marginRight: mobile ? '10px' : '' }}>{returnCollegeName(res.college_id)}</div>

              <div className='dca-userProfile-collegeInterest-row'>
                <Select
                  className="dca-userProfile-collegeInterest-select-fit"
                  value={{ value: res.fit, label: returnLabel(res.fit) }}
                  isSearchable={false}
                  options={options}
                  onChange={(selectedOption) =>
                    handleUserSelectedFitSelect(selectedOption, res.id)
                  }
                  styles={selectStyles(res.fit)} />
                <i className="bi bi-x align-self-center" style={{ marginLeft: '10px', cursor: 'pointer' }}
                  onClick={() => {
                    handleRemoveCollege(res.user_profile_id, res.college_id)
                  }}></i>
              </div>

            </div>

            {separatorElement(index)}
          </div>
        )}
      </div>

    </div >
  ) : <LoadingSpinner title={'Colleges of Interest'} />
}

export { CollegesOfInterest }